export const skills = [
  { name: 'HTML5', icon: 'fab fa-html5 text-orange-600', color: 'text-orange-600' },
  { name: 'CSS3', icon: 'fab fa-css3-alt text-blue-600', color: 'text-blue-600' },
  { name: 'JavaScript', icon: 'fab fa-js-square text-yellow-400', color: 'text-yellow-400' },
  { name: 'React', icon: 'fab fa-react text-cyan-400', color: 'text-cyan-400' },
  { name: 'Node.js', icon: 'fab fa-node-js text-green-600', color: 'text-green-600' },
  { name: 'Java', icon: 'fab fa-java text-red-500', color: 'text-red-500' },
  { name: 'SQL Server', icon: 'fas fa-database text-red-600', color: 'text-red-600' },
  { name: 'C#', icon: 'fab fa-microsoft text-purple-600', color: 'text-purple-600' },
  { name: 'Python', icon: 'fab fa-python text-blue-500', color: 'text-blue-500' },
  { name: 'Git', icon: 'fab fa-git-alt text-orange-500', color: 'text-orange-500' },
  { name: 'GitHub', icon: 'fab fa-github text-gray-800 dark:text-gray-200', color: 'text-gray-800 dark:text-gray-200' },
  { name: 'Tailwind CSS', icon: 'fas fa-wind text-cyan-500', color: 'text-cyan-500' }
]
